












export default {
  name: "BannerPartner",
  props: {
    link: String,
    action: Function,
  },
};
